import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { PostHogProvider } from "posthog-js/react";
import { WEBSITE_POSTHOG_OPTIONS } from "./posthogConfig";

const REACT_APP_PUBLIC_POSTHOG_KEY =
  "phc_mXargtOitl6dfCQBdTEVn4hpVpT1O31smEgot95ouTy";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <PostHogProvider apiKey={REACT_APP_PUBLIC_POSTHOG_KEY} options={WEBSITE_POSTHOG_OPTIONS}>
      <App />
    </PostHogProvider>

    <footer className="mt-2 p-3 text-center text-sm">
      <div className="bg-white rounded-lg shadow-lg p-4 inline-block">
        <p>
          &copy; {new Date().getFullYear()} Sea What You Save. All rights
          reserved.
        </p>
        <div className="mt-2 flex items-center justify-center gap-3">
          <a
            href="https://www.youtube.com/@seawhatyousave"
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-500 hover:text-red-600 transition-colors"
            aria-label="YouTube"
          >
            <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
              <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
            </svg>
          </a>
          <a
            href="https://www.tiktok.com/@seawhatyousave"
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-500 hover:text-black transition-colors"
            aria-label="TikTok"
          >
            <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
              <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"/>
            </svg>
          </a>
          <a
            href="https://www.facebook.com/profile.php?id=61577282317080"
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-500 hover:text-blue-700 transition-colors"
            aria-label="Facebook"
          >
            <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
              <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
            </svg>
          </a>
          <a
            href="https://www.reddit.com/u/seawhatyousave/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-500 hover:text-orange-600 transition-colors"
            aria-label="Reddit"
          >
            <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
              <path d="M14.238 15.348c.085.084.085.221 0 .306-.465.462-1.194.687-2.231.687l-.008-.002-.008.002c-1.036 0-1.766-.225-2.231-.688-.085-.084-.085-.221 0-.305.084-.084.222-.084.307 0 .379.377 1.008.561 1.924.561l.008.002.008-.002c.915 0 1.544-.184 1.924-.561.085-.084.223-.084.307 0zm-3.44-2.418c0-.507-.414-.919-.922-.919-.509 0-.922.412-.922.919 0 .506.414.918.922.918.508 0 .922-.412.922-.918zm4.04-.919c-.509 0-.922.412-.922.919 0 .506.414.918.922.918.508 0 .922-.412.922-.918 0-.507-.414-.919-.922-.919zM12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm5.492 13.614c.013.158.02.317.02.478 0 2.44-2.844 4.42-6.35 4.42-3.506 0-6.35-1.98-6.35-4.42 0-.16.007-.32.02-.478A1.613 1.613 0 0 1 4.2 12.1c0-.446.18-.852.473-1.146a1.613 1.613 0 0 1 2.17-.134c1.064-.742 2.515-1.216 4.12-1.272l.815-3.838.045-.01 2.705.574a1.14 1.14 0 0 1 1.071-.748 1.147 1.147 0 0 1 0 2.295 1.145 1.145 0 0 1-1.128-.96l-2.39-.508-.722 3.396c1.568.07 2.983.546 4.022 1.272a1.612 1.612 0 0 1 2.17.134c.293.293.473.699.473 1.146 0 .639-.372 1.19-.911 1.452z"/>
            </svg>
          </a>
        </div>
        <div className="mt-2 space-x-3">
          <a
            href="mailto:admin@seawhatyousave.com"
            className="text-blue-600 hover:text-blue-800 underline"
          >
            Contact Us
          </a>
          <span className="text-gray-400">|</span>
          <a
            href="/terms"
            className="text-blue-600 hover:text-blue-800 underline"
          >
            Terms and Conditions
          </a>
          <span className="text-gray-400">|</span>
          <a
            href="/privacy"
            className="text-blue-600 hover:text-blue-800 underline"
          >
            Privacy Policy
          </a>
        </div>
      </div>
    </footer>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
